import { Component, OnInit, Input } from '@angular/core';
import { IItem, AccountService, IFreeItem, IApiAccount } from '../../services/account.service';
import { ModalController } from '@ionic/angular';
//import { TranslateService } from '@ngx-translate/core';
import { ItemHelpers } from 'src/app/shared/helpers/item.helpers';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-redeem-offer-modal',
    templateUrl: './redeem-offer-modal.component.html',
    styleUrls: ['./redeem-offer-modal.component.scss'],
    standalone: false
})
export class RedeemOfferModalComponent implements OnInit {
  title: string = 'Nav.RedeemOffer';

  @Input() primary: IApiAccount;
  @Input() offer: IItem;

  showPromoCode: boolean = true;

  get lang() {
    return this.translationService.getLanguage();
  }

  constructor(
    private modalCtrl: ModalController,
    //private translateService: TranslateService
    private translationService: TranslationService
  ) { }

  ngOnInit() {   

   }

  onPromotionClicked(): void {
    this.showPromoCode = !this.showPromoCode;
  }

  onCardQrShow(value: boolean): void {
    if (value) {
      this.showPromoCode = false;
      return;
    }

    this.showPromoCode = true;
  }

  getOfferImage(): string {
    return ItemHelpers.getOfferImage(this.offer);
  }

  getItemDescription(item: IFreeItem) {
    return ItemHelpers.getDescriptionTrans(item, this.lang);
  }

  getItemTerms(item: IFreeItem) {
    return ItemHelpers.getTermsTrans(item, this.lang);
  }

  cancel() {
    this.modalCtrl.dismiss(null);
  }
}
